module.exports = __webpack_public_path__ + "img/alerta_2.289d978a.png";